import { FaRegTrashAlt } from 'react-icons/fa';
import { InferType, object, ObjectSchema, string } from 'yup';

import { SetInvestmentSpacePayload, SpaceReadModel } from '@client/api';
import { Button, TableCell, TableRow } from '@client/toolkit';

import { InvestmentSpaceAddress } from './investment-space-address.component';

type FormModel = SetInvestmentSpacePayload;

const schema: ObjectSchema<FormModel> = object({
  id: string().nullable(),
  spaceId: string().required(),
  priceId: string().nullable()
});

type FormValues = InferType<typeof schema>;

export const investmentSpaceSchema = schema;
export type InvestmentSpaceFormData = FormValues;

interface InvestmentSpaceItemFormProps {
  fieldIndex: number;
  space?: SpaceReadModel;
  isFetching?: boolean;
  onRemove?: (fieldIndex: number) => void;
}

export function InvestmentSpaceItemForm({
  fieldIndex,
  space,
  isFetching,
  onRemove,
}: InvestmentSpaceItemFormProps) {
  return (
    <TableRow verticalAlign="middle">
      <TableCell loading={isFetching}>
        <div className="flex items-center justify-end">
          <div className="flex-1">
            <InvestmentSpaceAddress
              name={space?.name}
              address={space?.address?.formattedAddress}
            />
          </div>
          <Button
            className="ml-2"
            size="xs"
            color="secondary-light"
            disabled={typeof onRemove !== 'function' || isFetching}
            onClick={() => {
              if (typeof onRemove !== 'function') {
                return;
              }
              onRemove(fieldIndex);
            }}
          >
            <FaRegTrashAlt />
          </Button>
        </div>
      </TableCell>
    </TableRow>
  );
}
